import { createPinia } from "pinia";
import { piniaStoragePlugin } from "./plugins/storage";
const store = createPinia();
store.use(piniaStoragePlugin);

export default store;
